import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  // FormGroup,
  // Button,
  // Label,
  // Input,
  Container,
  // CustomInput,
  // InputGroup,
  // Form,
  // InputGroupAddon,
} from "reactstrap";
import { Link } from "react-router-dom";
// import { AvForm, AvField, AvInput } from "availity-reactstrap-validation";
// import avatar2 from "../../assets/images/users/avatar-2.jpg";

import { connect } from "react-redux";
import "./Masters.scss";

import * as Departments from "../../store/Masters/Departments/actions";
import * as Locations from "../../store/Masters/Locations/actions";
import * as quality from "../../store/Masters/quality/actions";
import * as SubLocations from "../../store/Masters/SubLocations/actions";
import * as Vendor from "../../store/Masters/Vendors/actions";
import * as Category from "../../store/Masters/Category/actions";
import * as Section from "../../store/Masters/Section/actions";
import * as BasicUnit from "../../store/Masters/BasicUnit/actions";
import * as Taxs from "../../store/Masters/Taxs/actions";
import * as Menus from "../../store/Masters/Menus/actions";
import * as MenuItems from "../../store/Masters/MenuItems/actions";
import * as PrefixCode from "../../store/Masters/PrefixCode/actions";
import * as ProductGroup from "../../store/Masters/ProductGroups/actions";
// import * as OrderLocations from "../../store/Masters/OrderLocations/action";

import {
  getMastersMenu,
  // add_menu,
  // delete_menu,
  // put_menu
} from "../../store/Masters/MastersMenu/actions";
class Masters extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.props.getMastersMenu();
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                <h3 className="card-title-18 pt-2">Masters Dashboard</h3>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={12}>
                    {this.props.mastersMenuList.menuitems?.length !== 0 ? (
                      <h3 className="card-title-15 pt-2">Company</h3>
                    ) : (
                      <h3 className="card-title-15 text-center text-danger pt-2">
                        You don't have a permission to access
                      </h3>
                    )}
                    {/* <hr className="my-3" /> */}
                  </Col>
                  <Col md={12}>
                    <div className="Master-dashboard">
                      <div className="Master-dashboard-menu">
                        <Row className="mb-2">
                          {this.props.mastersMenuList.menuitems &&
                            this.props.mastersMenuList.menuitems
                              .sort((a, b) =>
                                a.sequence > b.sequence ? 1 : -1
                              )
                              .map((report, key) => (
                                <Col md={4} key={key}>
                                  <div className="Master-dashboard-item mb-2 ">
                                    <div className="title-box d-inline-block">
                                      <span className="mt-4">
                                        {report.title}
                                      </span>
                                    </div>

                                    <div className="view-box float-right">
                                      <Link
                                        to="#"
                                        onClick={() =>
                                          this.props[report.link]({
                                            id: 0,
                                          })
                                        }
                                        className="waves-effect ml-2"
                                      >
                                        <i className="ri-add-fill"></i>
                                      </Link>
                                      <Link
                                        to={report.link}
                                        className="waves-effect ml-2"
                                      >
                                        <i className="ri-menu-fill"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { mastersMenuList } = state.MastersMenu;
  return { mastersMenuList };
};

export default withRouter(
  connect(mapStatetoProps, {
    getMastersMenu,
    "/Departments": Departments.model_open,
    "/Locations": Locations.model_open,
    "/quality": quality.model_open,
    "/SubLocations": SubLocations.model_open,
    "/OrderLocations": () => window.location.replace("/AddOrderLocations/0"),
    "/OrderLocationTemplate": () =>
      window.location.replace("/AddOrderLocationTemplate/0"),
    // "/quality": () => window.location.replace("/AddQuality/0"),
    "/Vendors": Vendor.model_open,
    "/Category": Category.model_open,
    "/Section": Section.model_open,
    "/BasicUnit": BasicUnit.model_open,
    "/Taxs": Taxs.model_open,
    "/Menus": Menus.model_open,
    "/MenuItems": MenuItems.model_open,
    "/Products": () => window.location.replace("/AddProducts/0"),
    "/ProductQuality": () => window.location.replace("/AddProductsQuality/0"),
    "/PrefixCode": PrefixCode.model_open,
    "/ProductGroup": ProductGroup.pGroupModel_open,
  })(Masters)
);
